import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import './AutoComplete.css';

export default class ReactGoogleAutocomplete extends React.Component {

    static propTypes = {
        name: PropTypes.string,
        onTextChanged: PropTypes.func,
        onPlaceSelected: PropTypes.func,
        onChange: PropTypes.func,
        types: PropTypes.array,
        componentRestrictions: PropTypes.object,
        bounds: PropTypes.object,
        value: PropTypes.any
    };

    constructor(props) {
        super(props);
        this.autocomplete = null;
        this.state = {
            value: props.value,
        };
    }

    static getDerivedStateFromProps(props,currentState){

        if(!_.isEqual(props.value,currentState.value)){

            return {
                value: props.value
            };

        }

        return  null;
    }

    componentDidMount() {

        try {

            const google = window.google;

            const {types = ['(cities)'], componentRestrictions, bounds } = this.props;

            const config = {
                types,
                bounds,
            };

            if (componentRestrictions) {
                config.componentRestrictions = componentRestrictions;
            }

            this.autocomplete = new google.maps.places.Autocomplete(this._input, config);

            this.autocomplete.addListener('place_changed', this.onSelected.bind(this));

        }
        catch(ex) {
            console.log('Failed initializing google places');
        }

    }

    onSelected() {

        let place = this.autocomplete.getPlace();

        if (this.props.onPlaceSelected) {
            this.props.onPlaceSelected(place);
        }

        const value = {
            text: this.getPlaceText(),
            lat: place && place.geometry ?  place.geometry.location.lat() : null,
            lng: place && place.geometry ?  place.geometry.location.lng() : null,
        };

        //
        if(this.props.onChange){
            this.props.onChange(value);
        }

        this.setState({
            value
        });

    }

    getPlaceFull(){

        const { text , lat , lng } = this.state.value;
        let place = this.autocomplete ? this.autocomplete.getPlace() : null;
        return {
            text: text,
            lat: text.length === 0 ? null : (_.isNil(lat) ? lat : (place && place.geometry ?  place.geometry.location.lat() : undefined)),
            lng: text.length === 0 ? null : (_.isNil(lng) ? lng : (place && place.geometry ?  place.geometry.location.lng() : undefined))
        };
    }

    getPlaceText(){
        return this._input.value;
    }

    setLocation(value , lat, lng) {

        this.setState({
            value: {
                text: value,
                lat: _.isNil(lat) ? null : lat,
                lng: _.isNil(lng) ? null : lng
            }
        });

    }

    clearInput(){

        this.setState({
            value: null
        });

    }

    focus(){
        this._input.focus();
    }

    render() {

        const props = this.props;
        const { onPlaceSelected, types, componentRestrictions, bounds , onTextChanged , value , ...rest } = props;

        return (<div style={{width: '100%'}}>
                <input ref={r => this._input = r}
                    name={this.props.name}
                    className={this.props.className}
                    value={_.isNil(this.state.value) ? "" : this.state.value.text}
                    {...rest}
                    onChange={evt => {

                        let _value = evt.target.value;

                        if(onTextChanged)
                            onTextChanged(_value);

                        let _place = _value.length === 0 ?  null : {
                            text: _value,
                            lat: null,
                            lng: null
                        };

                        this.setState({
                            value: _place
                        });

                        //
                        if(props.onChange)
                            props.onChange(_place);

                    }}/>

            </div>
        );
    }
}

export class ReactCustomGoogleAutocomplete extends React.Component {

    static propTypes = {
        input: PropTypes.node.isRequired,
        onOpen: PropTypes.func.isRequired,
        onClose: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        const google = window.google;
        this.service = new google.maps.places.AutocompleteService();
    }

    onChange(e) {
        const { types=['(cities)'] } = this.props;

        if(e.target.value) {
            this.service.getPlacePredictions({input: e.target.value, types}, (predictions, status) => {
                if (status === 'OK' && predictions && predictions.length > 0) {
                    this.props.onOpen(predictions);
                    console.log(predictions);
                } else {
                    this.props.onClose();
                }
            });
        } else {
            this.props.onClose();
        }
    }

    componentDidMount() {
        const google = window.google;
        if (this.props.input.value) {
            this.placeService = new google.maps.places.PlacesService(this.refs.div);
            this.placeService.getDetails({placeId: this.props.input.value}, (e, status) => {
                if(status === 'OK') {
                    this.refs.input.value = e.formatted_address;
                }
            });
        }
    }

    render() {
        return (
            <div>
                {React.cloneElement(this.props.input,
                    {
                        ...this.props,
                        ref: 'input',
                        onChange: (e) => {
                            this.onChange(e);
                        },
                    }
                )}
                <div ref="div"></div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/AutoCompleteInput/AutoCompleteInput.js